<template>
  <div class="page-container" v-if="currentNews && currentNews.title">
    <h1 class="page-title">{{ currentNews.title }}</h1>
    <p class="page-date" v-if="currentNews.date">{{ currentNews.date }}</p>
    <div class="content" :class="contentLangClass">
      <template v-for="(section, index) in contentSections" :key="index">
        <div class="content-section">
          <div class="text-block" v-html="formatSection(section)"></div>
        </div>
        <!-- picture1 after section 0 -->
        <div v-if="index === 0 && (currentNews as any).other?.picture1" class="content-section image-section">
          <div class="image-container">
            <img :src="(currentNews as any).other.picture1.url" :alt="(currentNews as any).other.picture1.caption || 'News Image'">
            <p v-if="(currentNews as any).other.picture1.caption" class="image-caption">{{ (currentNews as any).other.picture1.caption }}</p>
          </div>
        </div>
        <!-- picture2 after section 2 -->
        <div v-if="index === 2 && (currentNews as any).other?.picture2" class="content-section image-section">
          <div class="image-container">
            <img :src="(currentNews as any).other.picture2.url" :alt="(currentNews as any).other.picture2.caption || 'News Image'">
            <p v-if="(currentNews as any).other.picture2.caption" class="image-caption">{{ (currentNews as any).other.picture2.caption }}</p>
          </div>
        </div>
      </template>
    </div>
  </div>
  <div v-else class="page-container">
    <p>新闻内容未找到</p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useLangStore } from '../../../pinia/stores/lang';
import zhData from '../../../i18n/zh';
import enData from '../../../i18n/en';

const langStore = useLangStore();

const contentLangClass = computed(() =>
  langStore.currentLang.startsWith('zh') ? 'lang-zh' : 'lang-en'
);

const currentNews = computed(() => {
  const translationData = langStore.currentLang.startsWith('zh') ? zhData : enData;
  const newsList = translationData.pages.news.company.news.list;
  const newsItem = newsList.find((news: any) => news.id === 'chaocixineng25T');
  return newsItem || {};
});

const contentSections = computed(() => {
  const content = (currentNews.value as any)?.content || '';
  return content ? content.split('---').filter((p: string) => p.trim()) : [];
});

const formatSection = (content: string) => {
  if (!content) return '';
  return `<p>${content.replace(/<br\s*\/?>\s*<br\s*\/?>/gi, '</p><p>')}</p>`;
};
</script>

<style scoped>
.page-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  font-family: 'Microsoft YaHei', Arial, 'PingFang SC', sans-serif;
}

.page-title {
  font-size: 28px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
  line-height: 1.4;
  text-align: center;
}

.page-date {
  color: #666;
  font-size: 14px;
  margin-bottom: 30px;
  text-align: right;
}

.content {
  line-height: 1.8;
  color: #444;
}

.content-section {
  margin-bottom: 20px;
}

/* 中文正文首行缩进 2 个汉字位 */
.content.lang-zh .text-block :deep(p) {
  margin-bottom: 15px;
  text-align: justify;
  font-size: 16px;
  text-indent: 2em;
}

/* 英文正文不缩进 */
.content.lang-en .text-block :deep(p) {
  margin-bottom: 15px;
  text-align: justify;
  font-size: 16px;
  text-indent: 0;
}

/* 小标题蓝色 */
.text-block :deep(h3) {
  color: #0066cc;
  font-weight: bold;
  margin-top: 24px;
  margin-bottom: 12px;
}

/* 链接蓝色可点击 */
.text-block :deep(a) {
  color: #1677ff;
  text-decoration: underline;
  cursor: pointer;
}

.text-block :deep(a:hover) {
  color: #0958d9;
}

.image-section {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 20px;
  margin-bottom: 20px;
}

.image-container {
  width: 100%;
  text-align: center;
}

.image-container img {
  max-width: 100%;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.image-caption {
  margin-top: 8px;
  color: #666;
  font-size: 14px;
  font-style: italic;
}
</style>
